import { NavLink } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ProviderContext } from '../../provider/Provider'
import localforage from 'localforage'

const CheckoutForm = () => {
  const { shoppingCart, couponValue, setCouponValue, addedCoupon, setAddedCoupon} = useContext(ProviderContext)

  const { register, handleSubmit, reset } = useForm()
  const [checked, setChecked] = useState(false)

  const [totalValue, setTotalValue] = useState(0)
  const [subTotalValue, setSubTotalValue] = useState(0)

  
  useEffect(() => {
    localforage.getItem('addedCoupon').then((data) => {
      if (data) {
        setAddedCoupon(data)
      }
    })
  }, [])

  const [time, setTime] = useState(null)
  const [validCoupon, setValidCoupon] = useState(null)
  const [coupon, setCoupon] = useState('')
  
  useEffect(() => {
    localforage.getItem('couponValue').then((data) => {
      if (data) {
        setCouponValue(data)
      }
    })
  }, [])

  const availableCoupons = {
    '10%DISCOUNT': 0.1,
    '20%DISCOUNT': 0.2,
    '30%DISCOUNT': 0.3,
    '40%DISCOUNT': 0.4,
    '50%DISCOUNT': 0.5,
    '60%DISCOUNT': 0.6,
    '70%DISCOUNT': 0.7,
    '80%DISCOUNT': 0.8,
    '90%DISCOUNT': 0.9,
    '100%FREE': 1.0
  }

  const onSubmit = (data) => {
    setCoupon('')
    if (time) {
      clearTimeout(time)
    }
    if (data.Coupon !== '') {
      const validCoupon = Object.keys(availableCoupons).filter((value) => {
        return value === data.Coupon
      })

      if (validCoupon.length !== 0) {
        setCouponValue(subTotalValue * availableCoupons[validCoupon])
        setValidCoupon(true)
        setTime(
          setTimeout(() => {
            setAddedCoupon(true)
            setValidCoupon(null)
          }, 3000)
        )
      } else {
        setValidCoupon(false)
        setTime(
          setTimeout(() => {
            setValidCoupon(null)
          }, 3000)
        )
      }
    } else {
      setValidCoupon('empty')
      setTime(
        setTimeout(() => {
          setValidCoupon(null)
        }, 3000)
      )
    }
    reset()
  }

  
  

  const CouponMessage = () => {
    if (validCoupon === 'empty') {
      return 'Please enter a valid code.'
    } else if (validCoupon === true && addedCoupon === false) {
      return 'Coupon has been applied succesfully.'
    } else if (validCoupon === true && addedCoupon === true) {
      return 'Coupon has been replaced succesfully.'
    } else if (validCoupon === false) {
      return 'Invalid code.'
    }
  }

  useEffect(() => {
    setSubTotalValue(
      shoppingCart
        .map((data) => {
          return data.price * data.quantity
        })
        .reduce((a, b) => a + b, 0)
    )
  }, [shoppingCart])

  useEffect(() => {
    if (couponValue === 0) setTotalValue(subTotalValue)
    else {
      setTotalValue(subTotalValue - couponValue)
      setCouponValue(subTotalValue * 0.2)
    }
  }, [subTotalValue])

  useEffect(() => {
    setTotalValue(subTotalValue - couponValue)
  }, [couponValue])

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const data = { Coupon: e.target.value }
      onSubmit(data)
      e.preventDefault()
    }
  }

  return (
    <div className="border-2 relative border-gray-400 rounded-lg w-11/12 lg:w-1/3 h-min flex flex-col items-center p-5 gap-4">
      <div
        className={` absolute left-1/2 -translate-x-1/2 w-full text-center -top-10 px-5 py-1 bg-black text-[#F3F3F3] rounded-md duration-500 ${
          validCoupon === null ? 'hidden' : 'animate-couponAnimation'
        }`}
      >
        {CouponMessage()}
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="relative flex flex-row gap-2"
      >
        <input
          type="text"
          {...register('Coupon')}
          value={coupon}
          onChange={(e) => {
            setCoupon(e.target.value.replace(/ /g, ''))
          }}
          onKeyDown={handleKeyDown}
          placeholder="Discount code"
          className="border-2 rounded-lg px-2 py-1 w-full"
        ></input>
        <input type="submit" hidden />
        <input
          type="submit"
          className="border-[2px] px-2 py-1 rounded-lg border-black font-semibold duration-200 hover:bg-red-600 hover:text-[#F3F3F3]"
          value="Apply"
        ></input>
      </form>
      <span className="w-full border-t-2 border-gray-400"></span>
      <ul className="grid grid-cols-2 justify-between w-full text-gray-400">
        <li className={`${couponValue === 0 ? 'hidden' : 'visible'}`}>
          Discount
        </li>
        <li className={` ${couponValue === 0 ? 'hidden' : 'visible'} text-end`}>
          {couponValue.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          })}
        </li>
        <li className="">Subtotal</li>
        <li className="text-end">
          {subTotalValue.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          })}
        </li>
      </ul>
      <span className="w-full border-t-2 border-gray-400"></span>
      <ul className="flex flex-row justify-between w-full text-xl font-bold">
        <li>Total</li>
        <li>
          {totalValue.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          })}
        </li>
      </ul>
      <form className="">
        <input
          type="checkbox"
          onClick={() => {
            setChecked(!checked)
          }}
        />{' '}
        I accept the{' '}
        <a
          href="../assets/documents/GMCVS.pdf"
          className="text-blue-600"
          target="_blank"
        >
          Terms & Conditions
        </a>
      </form>
      <button
        className={` text-[#F3F3F3] w-full py-3 font-semibold duration-200 ${
          checked ? 'bg-red-600' : 'bg-gray-300 cursor-default'
        }`}
      >
        <a
          rel="noopener noreferrer"
          target="_blanck"
          href="https://www.linkedin.com/in/gabriel-mendez-m/"
          className={`${checked ? 'visible' : 'hidden'}`}
        >
          PROCEED TO CHECKOUT
        </a>
        <p className={`${checked ? 'hidden' : 'visible'}`}>
          PROCEED TO CHECKOUT
        </p>
      </button>
      <NavLink to="/products" className="underline underline-offset-2">
        Continue Shopping
      </NavLink>
    </div>
  )
}

export default CheckoutForm
